@app.directive 'higherLogicComments', ($window, csConfig) ->
  restrict: 'E'
  scope: {
    vanillaIdentifier: '='
  }

  link: ($scope, element, attrs) ->
    installComments = ->
      # Validate vanillaIdentifier is present
      unless $scope.vanillaIdentifier
        console.error "vanillaIdentifier is not available"
        return

      # Environment-based forum URL mapping
      forumUrlMapping = {
        'staging': 'https://uat-community.chefsteps.com/'
        'production': 'https://community.chefsteps.com/'
      }

      # Get forum URL based on current environment
      vanillaForumUrl = forumUrlMapping[csConfig.env]

      # Check if community is configured for this environment
      unless vanillaForumUrl
        console.warn "Higher Logic community is not configured for environment: #{csConfig.env}"
        return

      # Set global variables required by Vanilla embed script
      $window.vanilla_forum_url = vanillaForumUrl
      $window.vanilla_identifier = "activity-#{$scope.vanillaIdentifier}"

      # Create and append the Vanilla embed script
      vanillaScript = document.createElement('script')
      vanillaScript.type = 'text/javascript'
      timestamp = new Date().getTime()
      vanillaScript.src = "#{vanillaForumUrl}/js/embed.js"

      # Append script to head or body
      (document.getElementsByTagName('head')[0] or document.getElementsByTagName('body')[0]).appendChild(vanillaScript)

    $scope.$watch 'vanillaIdentifier', (newValue, oldValue) ->
      if newValue
        installComments()

  templateUrl: "/assets/templates/components/higherLogicComments/higherLogicComments.html"
